import { IDeepCopy } from "@common/interfaces/i-deep-copy";
import { FilterDef } from '@common/data-models/navigation/filter-def';
import { ViewStateDef } from "@common/data-models/navigation/viewstate-def";

export class ViewStateSequence implements IDeepCopy<ViewStateSequence> {

    public viewstates: Array<ViewStateDef> = [];

    private onChange: (value: any) => any;
    public set OnChange(f: (v: any) => any) {
        this.onChange = f;
        for (let vs of this.viewstates) {
            vs.OnChange = (v) => {
                this.onChange(v);
            }
        }
    }

    public push(vs: ViewStateDef) {
        this.viewstates.push(vs);
        if (this.OnChange) {
            vs.OnChange = (v) => {
                this.OnChange(v);
            }
        }
    }

    public toJSON() {
        let json: Array<string> = [];
        for (let vs of this.viewstates) {
            if (vs.Selected) json.push(vs.Guid);
        }
        return JSON.stringify(json);
    }

    public deepCopy(): ViewStateSequence {
        let ret = new ViewStateSequence();
        for (let vs of this.viewstates) {
            ret.push(vs.deepCopy());
        }
        return ret;
    }

    public get Valid(): boolean {
        for (let vs of this.viewstates) {
            if (vs.Selected) return true;
        }
        return false;
    }
}
